import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase, Stack, Typography } from '@mui/material';

// project import
import LogoIcon from 'assets/images/logo/logo.png';
import FullLogoIcon from 'assets/images/logo/logo_full.png';
import LogoMain from 'assets/images/logo/company.png';
import RfidLogo from 'assets/images/layer-enhancement/rfidlogo.svg';
import config from 'config';
import { isUserLoggedIn } from 'utils/common';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = ({ reverse, isIcon, sx, to }) => {
  const isLogin = isUserLoggedIn();
  return (
    <ButtonBase disableRipple component={Link} to={!to ? config.defaultPath : to} sx={sx}>
      {/* {isIcon ? <img src={LogoIcon} alt="icon_logo" height="120%" /> : <img src={LogoMain} alt="main_logo" height="180%" />} */}
      {!isLogin ? (
        isIcon ? (
          <img src={LogoIcon} alt="icon_logo" height="100%" />
        ) : (
          <img src={LogoMain} alt="main_logo" width="40%" />
        )
      ) : isIcon ? (
        <img src={LogoIcon} alt="icon_logo" height="100%" />
      ) : (
        <Stack direction="row" spacing={2} alignItems="center">
          <img src={FullLogoIcon} alt="main_logo" width="50%" />
        </Stack>
      )}
      {/* {isIcon ? <img src={LogoIcon} alt="icon_logo" height="120%" /> : <img src={LogoMain} alt="main_logo" width='40%'/>}
    {isIcon ? <img src={RfidLogo} alt="icon_logo" height="120%" /> : <img src={RfidLogo} alt="main_logo" width='40%'/>} */}
    </ButtonBase>
  );
};

LogoSection.propTypes = {
  src: PropTypes.string,
  reverse: PropTypes.bool,
  isIcon: PropTypes.bool,
  sx: PropTypes.object,
  to: PropTypes.string
};

export default LogoSection;
